// extracted by mini-css-extract-plugin
module.exports = {"style":{"fontFamily":"'__neueMachina_22d9aa', '__neueMachina_Fallback_22d9aa'","fontWeight":400},"className":"__className_22d9aa"};